// Auto-generated from gen_coverage_report.ts
// DO NOT EDIT THIS FILE DIRECTLY

import { Coverage, CoverageTotals, Pulls, Tags, TranslationTotals } from './coverage.d';

export const coverage: Coverage = {};

export const coverageTotals: CoverageTotals = {
  byExpansion: {},
  byContentType: {},
  overall: {
    raidboss: 0,
    oopsy: 0,
    total: 0,
  },
};

const defaultTranslations = {
  totalFiles: 0,
  translatedFiles: 0,
  missingFiles: 0,
  errors: 0,
} as const;

export const translationTotals: TranslationTotals = {
  de: { ...defaultTranslations },
  fr: { ...defaultTranslations },
  ja: { ...defaultTranslations },
  cn: { ...defaultTranslations },
  ko: { ...defaultTranslations },
  tc: { ...defaultTranslations },
};

export const tags: Tags = {};

export const pulls: Pulls = [];
